import { render, staticRenderFns } from "./Oxigeno.vue?vue&type=template&id=0c4b7736"
import script from "./Oxigeno.vue?vue&type=script&lang=js"
export * from "./Oxigeno.vue?vue&type=script&lang=js"
import style0 from "./Oxigeno.vue?vue&type=style&index=0&id=0c4b7736&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports